import { motion } from "motion/react";
import clsx from "clsx";
import { imgAvatar } from "@/shared/assets/img";
import { Color } from "@/domains/dialogue/constants/color";
import DialogueAnswerButton from "@/domains/dialogue/components/DialogueAnswerButton";

type Props = {
  fullName: string;
  options: { id: number; text: string }[];
  color?: Color;
  className?: string;
  onClickOption: (id: number) => void;
  activeOptionId?: number;
};

export default function DialogueSelfMessage({
  fullName,
  options,
  color = Color.Default,
  className,
  onClickOption,
  activeOptionId,
}: Props) {
  return (
    <motion.div
      initial={{ translateX: "100%", opacity: 0 }}
      animate={{ translateX: "0", opacity: 1 }}
      transition={{
        bounce: false,
        duration: 0.2,
        delay: 0.2,
      }}
      exit={{
        translateX: "-100%",
        opacity: 0,
      }}
      className={clsx(
        "w-fit w-max-[26.625rem] relative isolate flex flex-col p-5 gap-2.5 bg-dark-900 rounded-[0.875rem]",
        className,
      )}
    >
      <div className="absolute bg-dark-900 w-[0.5rem] h-[0.5rem] top-5 -right-[0.25rem] rotate-45" />

      <div className="flex items-start gap-3">
        <div className="flex flex-col gap-0.5 grow">
          <div className="flex flex-col text-15 font-bold">
            <div>{fullName}</div>
            <div className="mt-0.5 font-medium text-white/70">Варианты ответов:</div>
          </div>
        </div>
        <div
          className={clsx(
            "w-[2.625rem] aspect-square shrink-0 flex items-center justify-center",
            "border-2 border-white/20 rounded-[0.5rem]",
          )}
        >
          <img
            src={imgAvatar}
            alt=""
            className="w-[2.125rem] aspect-square shrink-0 rounded-[0.3rem]"
          />
        </div>
      </div>
      <div className="w-full flex flex-col gap-1.5">
        {options.map((option) => (
          <DialogueAnswerButton
            key={option.id}
            id={option.id}
            text={option.text}
            color={color}
            isActive={option.id === activeOptionId}
            onClick={onClickOption}
          />
        ))}
      </div>
    </motion.div>
  );
}
